<style>
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>

<template>
  <CCard>
    <CCardHeader
      class="bg-primary text-white border-0 font-weight-bold p-3 d-flex align-items-center"
    >
      Data Anggota Terverifikasi
        <template v-if="role_status && role_status.status_update">
        <CButton
          color="info"        
          class="btn-md ml-auto mr-2"
          @click="ubahStatus"
          >Ubah Status Anggota</CButton>
        </template>
        <template v-if="role_status && role_status.status_export_excel">
          <CButton
            color="info"        
            class="btn-md mr-2"
            @click="exportAnggota"
            >Ekspor Excel</CButton
          >
        </template>
        <template v-if="role_status && role_status.status_create">
        <CButton
          color="success"
          class="btn-md"
          @click="createData()"
          >Tambah</CButton
        >
        </template>
    </CCardHeader>
    <!-- Tabs -->
    <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
      <li class="nav-item">
        <router-link
          to="/keanggotaan/data-anggota/unverified"
          class="nav-link p-3 px-5 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          href="#data-anggota"
          role="tab"
          aria-controls="data-anggota"
          aria-selected="true"
          >Anggota Belum Terverifikasi
          <span class="badge badge-danger">{{ totalElement }}</span>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/keanggotaan/data-anggota"
          class="nav-link p-3 px-5 font-weight-bold text-white border-0"
          style="background-color: #486ba7"
          id="home-tab"
          data-toggle="tab"
          href="#data-anggota"
          role="tab"
          aria-controls="data-anggota"
          aria-selected="true"
          >
            Anggota Terverifikasi
            <span class="badge badge-success">{{ totalElementVerif }}</span>
          </router-link
        >
      </li>
    </ul>

    <!-- Data BPK -->
    <CCardBody>
      <CRow class="mb-3">
        <div class="col-sm-12 col-xl-12">          
          <div class="form-group">
            <label for class="font-weight-bold">Pilih Kategori Anggota</label>
            <select
              class="form-control"
              name
              id
              v-model="formData.namaKategori"              
            >
              <option value="" selected disabled>Pilih Kategori Anggota</option>
              <option value="default">Semua Data</option>
              <option
                v-for="(val, key) in dataKategori"
                :key="key"
                :value="val.namaKategori"
              >
                {{ val.namaKategori }}
              </option>
            </select>
          </div>
          <div class="text-right">
            <button class="btn btn-md btn-info mr-2" @click="resetFilter">Reset Filter</button>
            <button class="btn btn-md btn-success" @click="filterByKategori">Terapkan</button>
          </div>
        </div>
      </CRow>
      <CRow>
        <div class="col-sm-12 col-xl-2">
          <div class="form-group">
            <CSelect
              label="Data Perhalaman"
              class="float-left"
              @change="changePageSize"
              v-model.number="pageSize"
              :options="[10, 25, 100, 'Semua Data']"
            />
          </div>
        </div>

        <div class="col-sm-12 col-xl-3 ml-auto">
          <div class="form-group">
            <label for>Pencarian</label>
            <input
              type="text"
              name
              id
              class="form-control"
              placeholder="Cari Data ..."
              v-model="search"
            />
          </div>
        </div>
      </CRow>

      <CRow>
        <CCol lg="12" class="table-responsive">
          <CDataTable
            style="widht: 100% !important"
            :items="items"
            :fields="fields"
            hover
            sorter
          >
            <template #no="{ index }">
              <td class="py-2">{{indexed == 0 ? index + 1 : index + indexed + 1}}</td>
            </template>

            <template #no_anggota="{ item }">
              <td class="py-2 text-left font-weight-bold">
                <span
                  v-if="item.no_anggota == '' || item.no_anggota == null"
                  class="text-warning"
                  style="font-size: 12px"
                  >*Belum Memiliki Nomor Anggota</span
                >
                <span v-else>{{ item.no_anggota }}</span>
              </td>
            </template>
            <template #nama_kategori="{ item }">
              <td class="py-2 text-left font-weight-bold">
                <span
                  v-if="item.nama_kategori == '' || item.nama_kategori == null"
                  class="text-warning"
                  style="font-size: 12px"
                  >*Belum Memiliki Kategori Anggota</span
                >
                <span v-else>{{ item.nama_kategori }}</span>
              </td>
            </template>
            <template #nama_lengkap="{ item, index }">
              <td
                class="py-2 text-left text-info"
                style="cursor: pointer"
                @click="detailUser(item, index)"
              >
                {{ item.nama_lengkap ? item.nama_lengkap : "-" }}
              </td>
            </template>
            <!-- <template #tanggal_jatuh_tempo="{item}">
              <td
                class="py-2 text-center"
              >{{item.tanggal_jatuh_tempo ? item.tanggal_jatuh_tempo : "-"}}</td>
            </template> -->
            <template #no_handphone="{ item }">
              <td class="py-2 text-center">
                {{ item.no_handphone ? item.no_handphone : "-" }}
              </td>
            </template>
            <template #status_kartu_anggota="{ item }">
              <td class="py-2 text-center">
                <span class="font-weight-bold text-success" v-if="item.status_kartu_anggota == 'Aktif'">Aktif</span>
                <span class="font-weight-bold text-danger" v-else-if="item.status_kartu_anggota == 'Tidak Aktif'">Tidak Aktif</span>
                <span class="font-weight-bold text-warning" v-else-if="item.status_kartu_anggota == 'Cuti'">Cuti</span>
                <span class="font-weight-bold text-warning" v-else-if="item.status_kartu_anggota == 'Anggota Kehormatan'">Anggota Kehormatan</span>
                <span class="font-weight-bold text-danger" v-else>Tidak Aktif</span>
              </td>
            </template>
            <template #no_telephone="{ item }">
              <td class="py-2 text-center">
                {{ item.no_telephone ? item.no_telephone : "-" }}
              </td>
            </template>
            <template #tanggal_daftar="{ item }">
              <td class="py-2 text-center">
                {{
                  item.tanggal_daftar ? formatDate(item.tanggal_daftar) : "-"
                }}
              </td>
            </template>
            <template #updated_at="{ item }">
              <td class="py-2 text-center">
                {{ item.updated_at ? formatDate(item.updated_at) : "-" }}
              </td>
            </template>
            <template #dok_verif="{ item }">
              <td>
                <button
                  class="btn btn-sm btn-success"
                  v-if="item.dok_verif == 1"
                >
                  Terverifikasi
                </button>
                <button class="btn btn-sm btn-danger" v-else>
                  Belum Terverifikasi
                </button>
              </td>
            </template>
            <template #aksi="{ item, index }">
              <td class="py-2 text-center d-flex align-items- center">
                <template v-if="role_status && role_status.status_update">
                <CButton
                  v-c-tooltip="'Sanksi'"
                  color="danger"
                  class="btn-sm text-white mr-1"
                  @click="sanksiForm(item, index)"
                  square
                >
                  <font-awesome-icon icon="gavel" />
                </CButton>
                </template>
                <template v-if="role_status && role_status.status_read">
                <router-link :to="'/keanggotaan/data-anggota/kartu-anggota-madya/'+item.id_user" v-if="item.nama_kategori == 'Anggota Madya'">
                  <CButton v-c-tooltip="'Kartu Anggota'" color="success" class="btn-sm text-white mr-1" square>
                    <i class="fas fa-id-card"></i>
                  </CButton>
                </router-link>
                <router-link :to="'/keanggotaan/data-anggota/kartu-anggota-biasa/'+item.id_user" v-else-if="item.nama_kategori == 'Anggota Biasa'">
                  <CButton v-c-tooltip="'Kartu Anggota'" color="success" class="btn-sm text-white mr-1" square>
                    <i class="fas fa-id-card"></i>
                  </CButton>
                </router-link>
                <router-link v-else>
                  <CButton v-c-tooltip="'Kartu Anggota'" color="secondary" disabled class="btn-sm text-white mr-1" square>
                    <i class="fas fa-id-card"></i>
                  </CButton>
                </router-link>
                <router-link
                  :to="'/keanggotaan/data-anggota/data-diri/' + item.id_user"
                >
                  <CButton
                    v-c-tooltip="'Data Keanggotaan'"
                    color="warning"
                    class="btn-sm text-white"
                    square
                  >
                    <font-awesome-icon icon="user" />
                  </CButton> </router-link
                >&nbsp;&nbsp;
                </template>
                <template v-if="role_status && role_status.status_update">
                <CButton
                  v-c-tooltip="'Akses'"
                  color="info"
                  class="btn-sm mx-1"
                  square
                  @click="updateData(item, index)"
                >
                  <font-awesome-icon icon="key" /> </CButton
                >&nbsp;&nbsp;
                </template>
                <template v-if="role_status && role_status.status_delete">
                <CButton
                  v-c-tooltip="'Hapus'"
                  color="danger"
                  class="btn-sm"
                  square
                  @click="deleteData(item, index)"
                >
                  <font-awesome-icon icon="trash" />
                </CButton>
                </template>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float: right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />
        </CCol>
      </CRow>
      <CModal
        title="Ubah Status Anggota"
        :show.sync="myModalUbahStatus"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CForm >
          <CRow>
            <div class="modal-body">
             <CCol sm="12 ">
              <label  class="font-weight-bold">
                Unggah File
              
              </label>
              <br />
              <div class="custom-file text-truncate">
                <input
                  type="file"
                  class="custom-file-input"
                  id="customFileLangHTML"
                  ref="uploadFileMasterDokumen"
                  @change="fileUploadUbahStatus"                  
                />
                <label
                  class="custom-file-label"
                  for="customFileLangHTML"
                  data-browse="Unggah"
                >
                  {{ typeof fileUbahStatus === "string" ? fileUbahStatus : fileNameUbahStatus }}
                </label>                        
              </div>
            </CCol>
            </div>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Ubah Status Anggota</h6>
        </template>
        <template #footer>
          <CButton @click="myModalUbahStatus = false" color="danger">Tutup</CButton>
          <CButton @click="downloadFormatImport" color="info">Download Format</CButton>
          <CButton @click="postDataStatus"  color="success"
            >Simpan</CButton
          >
        </template>
      </CModal>
      <!-- End Modal -->
      
      <!-- Modal Tambah -->
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CForm v-on:submit.prevent="postData">
          <CRow>
            <div class="modal-body">
              <form>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <label for="nama_lengkap" class="font-weight-bold"
                      >Nama Lengkap</label
                    >
                    <input
                      type="nama"
                      class="form-control"
                      id="nama_lengkap"
                      placeholder="Masukkan Nama Lengkap"
                      v-model="formData.nama"
                      :class="{
                        'is-invalid': $v.formData.nama.$error,
                      }"
                      @input="setNama($event.target.value)"
                    />
                  </div>
                  <div class="form-group col-md-12">
                    <label for="email" class="font-weight-bold">Email</label>
                    <input
                      type="email"
                      class="form-control"
                      id="email"
                      placeholder="Masukkan Email"
                      v-model="formData.email"
                      :class="{
                        'is-invalid': $v.formData.email.$error,
                      }"
                      @input="setEmail($event.target.value)"
                    />
                  </div>
                  <div class="form-group col-md-12">
                    <label for="noTelephone" class="font-weight-bold"
                      >No. Telepon</label
                    >
                    <input
                      type="number"
                      class="form-control"
                      id="noTelephone"
                      placeholder="Masukkan No. Telepon"
                      v-model="formData.noTelephone"
                      :class="{
                        'is-invalid': $v.formData.noTelephone.$error,
                      }"
                      @input="setNoTelephone($event.target.value)"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <label for="password" class="font-weight-bold"
                    >Password</label
                  >
                  <input
                    type="password"
                    class="form-control"
                    id="password"
                    placeholder="Masukkan Password"
                    v-model="formData.password"
                  />
                </div>
                <CCol sm="12 mb-4 px-0">
                  <label for class="font-weight-bold">Status Akun</label>
                  <br />
                  <div class="d-flex align-items-center">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        class="custom-control-input"
                        name="customRadio"
                        value="active"
                        v-model="formData.status"
                        id="aktif"
                        checked
                      />
                      <label class="custom-control-label" for="aktif">Aktif</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        class="custom-control-input"
                        name="customRadio"
                        :value="null"
                        id="tidak_aktif"
                        v-model="formData.status"
                      />
                      <label class="custom-control-label" for="tidak_aktif"
                        >Tidak Aktif</label
                      >
                    </div>
                  </div>
                  
                </CCol>
                <CCol sm="12 mb-4 px-0">
                  <label for class="font-weight-bold">Status Anggota</label>
                  <br />
                  <select name="" id="" class="form-control" v-model="formData.statusKartuAnggota">
                    <option value="" disabled selected>Pilih Status</option>
                    <option value="Aktif">Aktif</option>
                    <option value="Tidak Aktif">Tidak Aktif</option>
                    <option value="Cuti">Cuti</option>
                    <option value="Anggota Kehormatan">Anggota Kehormatan</option>
                  </select>
                </CCol>
              </form>
            </div>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">{{ title }}</h6>
        </template>
        <template #footer>
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
          <CButton @click="postData"  color="success"
            >Simpan</CButton
          >
        </template>
      </CModal>
      <!-- End Modal -->

      <!-- Modal Detail User -->
      <CModal
        title="Modal title"
        :show.sync="modalDetail"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CRow>
          <div class="modal-body row my-n3">
            <div class="col-5">
              <p class="font-weight-bold">Nama Anggota</p>
              <p class="font-weight-bold">Kategori Anggota</p>
              <p class="font-weight-bold">No. Handphone</p>
              <p class="font-weight-bold">No. Telepon</p>
              <p class="font-weight-bold">Email</p>
            </div>
            <div class="col-7">
              <p>
                : {{ formData.nama_lengkap ? formData.nama_lengkap : " - " }}
              </p>
              <p>
                : {{ formData.nama_kategori ? formData.nama_kategori : " - " }}
              </p>
              <p>
                : {{ formData.no_handphone ? formData.no_handphone : " - " }}
              </p>
              <p>
                : {{ formData.no_telephone ? formData.no_telephone : " - " }}
              </p>
              <p>: {{ formData.email ? formData.email : " - " }}</p>
            </div>
          </div>
        </CRow>
        <template #header>
          <h6 class="modal-title h5 font-weight-bold">Detail Anggota</h6>
        </template>
        <template #footer>
          <CButton @click="modalDetail = false" color="danger">Tutup</CButton>
        </template>
      </CModal>
      <!-- End Modal -->

      <!-- Modal Sanksi -->
      <CModal
        title="Modal title"
        :show.sync="myModalsanksi"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CForm >
          <CRow>
            <div class="modal-body">
              <form>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <div class="form-group">
                      <label class="font-weight-bold">Pemberi Sanksi</label>
                      <select name="" class="form-control" id="" v-model="formSanksi.pemberiSanksi">
                        <option value="iapi">IAPI</option>
                        <option value="regulator">Regulator</option>
                      </select>
                    </div>
                    <div class="form-group" v-if="formSanksi.pemberiSanksi == 'regulator'">
                      <label class="font-weight-bold">Tipe Regulator</label>
                      <select name="" class="form-control" id="" v-model="formSanksi.tipeRegulator">
                        <option value="BPK">BPK</option>
                        <option value="OJK">OJK</option>
                        <option value="PPPK">PPPK</option>
                      </select>
                    </div>
                    <label class="font-weight-bold">Nomor</label>
                    <input
                      type="number"
                      class="form-control"
                      min="0"
                      placeholder="Nomor Sanksi"
                      v-model="formSanksi.nomorSanksi"
                      :class="{
                        'border-danger': $v.formSanksi.nomorSanksi.$error
                      }"
                    />
                  </div>
                  <div class="form-group col-md-12">
                    <label for="email" class="font-weight-bold">Sanksi</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Masukkan Nilai Sanksi"
                      min="0"
                      v-model="formSanksi.sanksi"
                      :class="{
                        'border-danger': $v.formSanksi.sanksi.$error
                      }"
                    />
                  </div>
                  <div class="form-group col-md-12">
                    <label for="noTelephone" class="font-weight-bold">Keterangan Sanksi</label>
                    <textarea
                      type="text"
                      class="form-control"
                      rows="5"
                      placeholder="Masukkan Keterangan Sanksi"
                      v-model="formSanksi.keterangan"
                      :class="{
                        'border-danger': $v.formSanksi.keterangan.$error
                      }"
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <label for="tgl_mulai" class="font-weight-bold">Tanggal Mulai</label>
                    <input
                      type="date"                      
                      class="form-control"
                      required
                      id="tgl_mulai"
                      placeholder="Masukkan Tanggal"
                      v-model="formSanksi.tanggalMulai"
                      :min="today"
                      :class="{
                        'is-invalid': $v.formSanksi.tanggalMulai.$error,                     
                      }"
                    />                    
                  </div>
                  <div class="form-group col-md-6">
                    <label for="tgl_exp" class="font-weight-bold">Tanggal Berakhir</label>
                    <input
                      type="date"                      
                      class="form-control"
                      id="tgl_exp"
                      required
                      placeholder="Masukkan Tanggal"
                      v-model="formSanksi.tanggalBerakhir"
                      @click="triggerValidationExpired"
                      :min="today"
                      :class="{
                        'is-invalid': $v.formSanksi.tanggalBerakhir.$error,
                      }"
                    />
                    <span class="text-danger" v-if="$v.formSanksi.tanggalBerakhir.$error">
                      *Kurang dari tanggal mulai
                    </span>
                  </div>
                </div>
              </form>
            </div>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Sanksi Anggota</h6>
        </template>
        <template #footer>
          <CButton @click="myModalsanksi = false" color="danger">Tutup</CButton>
          <CButton @click="postSanksi" color="success">Simpan</CButton
          >
        </template>
      </CModal>
      <!-- End Modal Sanksi -->
    </CCardBody>
    <!-- End Data BPK -->
  </CCard>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import moment from 'moment';
import DataKeanggotaanService from "@/services/keanggotaan/data-anggota.service";
import KategoriAnggotaService from "@/services/keanggotaan/kategori-anggota.service";
import SanksiService from "@/services/keanggotaan/sanksi/sanksi.service";
import { AlertUtils} from "@/mixins/AlertUtils";
import { exportUtils } from '@/mixins/exportUtils';
import BaseUrl from "@/services/base-url";

const fields = [
  {
    key: "no",
    sorter: false,
    filter: false,
  },
  {
    key: "no_anggota",
    label: "Nomor Anggota",
    _style: "font-weight: bold !important",
    sorter: false,
    filter: false,
  },
  {
    key: "nama_lengkap",
    label: "Nama Anggota",
    sorter: false,
    filter: false,
  },
  {
    key: "nama_kategori",
    label: "Kategori Anggota",
    sorter: false,
    filter: false,
  },
  {
// 
    key: "status_kartu_anggota",
    label: "Status",
    sorter: false,
    filter: false,
    _style: "text-align: center",
  },
  {
    key: "tanggal_daftar",
    label: "Tanggal Registrasi",
    sorter: false,
    filter: false,
    _style: "text-align: center",
  },
  {
    key: "updated_at",
    label: "Tanggal Terdaftar",
    sorter: false,
    filter: false,
    _style: "text-align: center",
  },
  {
    key: "aksi",
    _style: "width:10%; text-align: center",
    sorter: false,
    filter: false,
  },
];

export default {
  mixins: [
    AlertUtils,
    exportUtils
  ],
  name: "master-data-keanggotaan",
  data() {
    return {
      search: "",
      pageSize: 10,
      items: [],
      actionPost: "",
      validation: {
        namaKategori: false,
        nama_kategori: false,
        nama_lengkap: false,
        noTelephone: false,
        tangga_jatuh_tempo: false,
        no_handphone: false,
        email: false,
        nama: false,
        noTelephone: false,
      },
      
      dataKategori: [],
      formData: {
        namaKategori: "",
        nama_kategori: "",
        nama_lengkap: "",
        noTelephone: "",
        noTelephone: "",
        tangga_jatuh_tempo: "",
        statusKartuAnggota : "",
        no_handphone: "",
        email: "",
        nama: "",
        noTelephone: "",
        password: "",
        id_user: "",
        status: null,
      },

      formSanksi: {
        idUser: '',
        nama_lengkap: '',
        namaKategori: "",
        keterangan: '',
        nomorSanksi: '',
        sanksi: '',
        tanggalMulai: new Date().toISOString().slice(0, 10),
        tanggalBerakhir: new Date().toISOString().slice(0, 10),
        pemberiSanksi: 'iapi',
        tipeRegulator: 'BPK'
      },

      pagination: {
        totalPages: 0,
      },

      today: moment().format("YYYY-MM-DD"),

      title: "",
      fields,
      currentPage: 0,
      details: [],
      no: 1,
      status: false,
      indexed: 0,
      myModal: false,
      myModalsanksi: false,
      modalDetail: false,
      horizontal: { label: "col-3", input: "col-9" },
      totalElement: 0,
      totalElementVerif : 0,
      collapseDuration: 0,
      content: [],
      myModalUbahStatus : false,
      fileNameUbahStatus : null,
      fileUbahStatus : '',
      baseUrl : '',
      role_status : null
    };
  },
  mounted() {
    this.roleData();
    this.baseUrl = BaseUrl();

    this.today = moment().format("YYYY-MM-DD");
    this.getData("0", this.pageSize, "default", this.formData.namaKategori);
    this.getKategori();
    this.getTotalElement();
    this.getTotalElementVerif();
  },

  watch: {
    search: function (val) {
      clearTimeout(this.timeout);
      var vm = this;
      this.timeout = setTimeout(function () {
        vm.getData("0", vm.pageSize, vm.search, vm.formData.namaKategori);
      }, 1000);
    },
    currentPage: function (val) {
      var page = val - 1;
      this.indexed = page * this.pageSize;
      this.getData(
        val - 1,
        this.pageSize,
        this.search,
        this.formData.namaKategori
      );
    },
    myModal: function () {
      if (!this.myModal) {
        this.clearValidation();
      }
    },
    myModalsanksi: function() {
      if(!this.myModalsanksi) {
        this.$v.$reset();
      }
    }
  },

  validations: {
    formData: {
      email: { required, email },
      nama: { required },
      noTelephone: { required },
    },
    formSanksi: {                  
      nomorSanksi: { required },
      sanksi: { required },
      keterangan: { required },
      tanggalMulai: { required },
      tanggalBerakhir: { 
        required,
        isAfterDate(val, { tanggalMulai }) {
          return new Date(val) >= new Date(tanggalMulai);
        }
      },
    },
  },

  methods: {
    roleData()
      {
        var user = JSON.parse(localStorage.getItem('user'));
        var data = user.singleData.detail_user.roles.find(el => el.url === '/keanggotaan/data-anggota/unverified' );  
        this.role_status = data;
      },
    downloadFormatImport() {
      let routeData = this.baseUrl + "/files?filename=FORMAT_UPLOAD_UBAH_STATUS.xlsx&path=datamaster"; 
      window.open(routeData, "_blank");
    },
    fileUploadUbahStatus(e) {
      this.fileUbahStatus = e.target.files[0];
      this.fileNameUbahStatus = e.target.files[0].name;
      // comment console console.log(e.target.files);
    },
    postDataStatus() {
      var vm = this;
      if (typeof this.fileUbahStatus === "string") {
        vm.alertError("File Harus Diisi");
        return false
      }
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      
      var formData = {
        file : this.fileUbahStatus
      }
      DataKeanggotaanService.ubahStatusAnggotaExcel(formData)
      .then(response => {
        this.myModalUbahStatus = false
        loader.hide()
        vm.alertSuccess();
        vm.getData("0", this.pageSize, "default", this.formData.namaKategori);
      }).catch(error => {
          loader.hide();
          vm.alertError(error.response.data.message);

      })
    },
    ubahStatus() {
      this.myModalUbahStatus = true;
    },
    // ======= SANKSI ======= //

    triggerValidationExpired() {
      this.$v.formSanksi.tanggalBerakhir.$touch();
    },

    sanksiForm(item) {
      this.myModalsanksi = true;
      this.formSanksi.idUser = item.id_user;
      this.formSanksi [
        {
          pemberiSanksi: item.pemberiSanksi,
          tanggalBerakhir: new Date().toISOString().slice(0, 10),
        }
      ]
      this.actionPost = "insert";
      this.title = "Sanksi";
    },

    insertDataSanksi(formSanksi) {   
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });   
      var vm = this;
      SanksiService.postDataSanksi(formSanksi)
        .then((response) => {
          vm.myModalsanksi = false;
          vm.alertSuccess();
          loader.hide()
        })
        .catch((error) => {
          loader.hide()
          // comment console console.log(error);
          vm.alertError();
        });
    },

    postSanksi() {
      // alert("hai")
      this.$v.formSanksi.$touch();
      this.actionPost == "insert"
      if (this.$v.formSanksi.$invalid) {
        return;
      } else {          
        this.insertDataSanksi(this.formSanksi);
      }        
    },
    // ======= END SANKSI ======= //

    setNama(value) {
      this.formData.nama = value;
      this.$v.formData.nama.$touch();
      if (!this.$v.formData.nama.$error) {
        document.getElementById("nama_lengkap").classList.add("is-valid");
      }
    },
    setEmail(value) {
      this.formData.email = value;
      this.$v.formData.email.$touch();
      if (!this.$v.formData.email.$error) {
        document.getElementById("email").classList.add("is-valid");
      }
    },
    setNoTelephone(value) {
      this.formData.noTelephone = value;
      this.$v.formData.noTelephone.$touch();
      if (!this.$v.formData.noTelephone.$error) {
        document.getElementById("noTelephone").classList.add("is-valid");
      }
    },

    getTotalElement() {
      DataKeanggotaanService.getDataKeanggotaanUnverif(
        "0",
        "1",
        "default",
        "default"
      )
        .then((response) => {
          this.totalElement = response.data.data.totalElements;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },

    getTotalElementVerif() {
      
      DataKeanggotaanService.getDataKeanggotaan(
        "0",
        "1",
        "default",
        "default"
      )
        .then((response) => {
          this.totalElementVerif = response.data.data.totalElements;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },

    changePageSize(e) {
      // comment console console.log(e.target.value);
      var pageSize = "";

      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", pageSize, this.search, this.formData.namaKategori);
    },

    cariData() {
      this.getData("0", this.pageSize, this.search, this.formData.namaKategori);
    },

    pageChange() {
      this.getData(
        this.currentPage,
        this.pageSize,
        this.search,
        this.formData.namaKategori
      );
    },

    filterByKategori(e) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      var value = this.formData.namaKategori;
      DataKeanggotaanService.getDataKeanggotaan(
        0,
        this.pageSize,
        this.search,
        value
      )
        .then((response) => {
          this.items = response.data.data.content;

          this.pagination.totalPages = response.data.data.totalPages;
          this.currentPage = response.data.data.pageable.pageNumber + 1;
          loader.hide();
        })
        .catch((error) => {
          // comment console console.log(error);
          loader.hide();
        });
    },

    resetFilter() {
      this.formData.namaKategori = "";
    },

    formatDate(tanggal_daftar) {
      var tanggalTerdaftar = tanggal_daftar.split("-"); // ex input "2010-01-18"
      var tangarTerdaftarUpdate =
        tanggalTerdaftar[2].substr(0, 2) +
        "-" +
        tanggalTerdaftar[1] +
        "-" +
        tanggalTerdaftar[0];
      return tangarTerdaftarUpdate;
    },

    alertErrorUser() {
      this.$swal.fire({
        title: "Peringatan!",
        text:
          "Data Sedang Digunakan Di Modul Lain Sehingga Tidak Dapat Dihapus",
        icon: "errorr",
        showCancelButton: true,
      });
    },

    deleteData(item, index) {
      var vm = this;
      this.formData = item;

      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            DataKeanggotaanService.deleteDataAnggota(this.formData)
              .then((response) => {

                vm.alertDeleteSuccess();

                this.getData(
                  "0",
                  this.pageSize,
                  this.search,
                  this.formData.namaKategori
                );
              })
              .catch((error) => {
                vm.alertErrorUser();
              });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            vm.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    getData(currentPage, pageSize, filter, filterKategori) {
      if (filter == "") {
        var filters = "default";
      } else {
        var filters = filter;
      }
      if (filterKategori == "") {
        var filterKategoris = "default";
      } else {
        var filterKategoris = filterKategori;
      }
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });

      var vm = this;

      DataKeanggotaanService.getDataKeanggotaan(
        currentPage,
        pageSize,
        filters,
        filterKategoris
      )
        .then((response) => {
          loader.hide();
          vm.items = response.data.data.content;
          vm.pagination.totalPages = response.data.data.totalPages;          
          vm.currentPage = response.data.data.pageable.pageNumber + 1;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },

    getKategori() {
      KategoriAnggotaService.getAllKategoriAnggota()
        .then((response) => {
          // comment console console.log(response.data.data.content);
          this.dataKategori = response.data.data.content;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },

    createData() {
      this.myModal = true;
      this.formData = {
        namaKategori: "",
        nama_kategori: "",
        nama_lengkap: "",
        noTelephone: "",
        noTelephone: "",
        tangga_jatuh_tempo: "",
        no_handphone: "",
        email: "",
        nama: "",
        noTelephone: "",
        password: "",
        id_user: "",
      };
      this.actionPost = "insert";
      this.title = "Tambah";
    },

    updateData(item, index) {
      this.myModal = true;
      this.formData = item;
      this.formData.password = item.password;
      this.formData.nama = item.nama_lengkap;
      this.formData.noTelephone = item.no_handphone;
      this.formData.statusKartuAnggota = item.status_kartu_anggota
      if(item.status != null) {
        this.formData.status = "active"
      } else {
        this.formData.status = null
      }
      this.actionPost = "update";
      this.title = "Edit";
    },

    detailUser(item, index) {
      this.modalDetail = true;
      this.formData = item;
    },

    postData() {
      this.$v.formData.$touch();
      if (this.actionPost == "insert") {
        if (this.$v.formData.$invalid) {
          return;
        } else {
          this.insertData(this.formData);
        }
      } else if (this.actionPost == "update") {
        if (this.$v.formData.$invalid) {
          return;
        } else {
          this.putData();
        }
      }
    },

    insertData(formData) {
      var vm = this;
      DataKeanggotaanService.postDataAnggota(formData)
        .then((response) => {
          vm.myModal = false;
          vm.alertSuccess();
          this.getData(
            "0",
            this.pageSize,
            this.search,
            this.formData.namaKategori
          );
        })
        .catch((error) => {
          // comment console console.log(error);
          vm.alertError(error.response.data.message);
        });
    },

    putData() {
      var vm = this;
      DataKeanggotaanService.putDataAnggotaUrl(this.formData)
        .then((response) => {
          vm.myModal = false;
          vm.alertEditSuccess();
          this.getData(
            "0",
            this.pageSize,
            "default",
            this.formData.namaKategori
          );
        })
        .catch((error) => {
          // comment console console.log(error);

          vm.alertError(error.response.data.message);
        });
    },

    clearValidation() {
      this.$v.$reset();
      document.getElementById("nama_lengkap").classList.remove("is-valid");
      document.getElementById("email").classList.remove("is-valid");
      document.getElementById("noTelephone").classList.remove("is-valid");
    },

    exportAnggota() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      DataKeanggotaanService.exportVerifAnggota()
      .then(response => {
        loader.hide()
        this.exportData(response.data, 'DataAnggotaTerverifikasi')
        this.alertExportSuccess(); 
      }).catch(error => {
        loader.hide()
        this.alertExportFailed();
      })
    },
   
  },
};
</script>